module.exports = __webpack_public_path__ + "img/specials.f5966343.svg";